import { Close } from '@interhyp/platform-icons';
import { animated, useTransition } from '@react-spring/web';
import classnames from 'classnames';
import React, { Children, cloneElement, useCallback, useMemo, useState } from 'react';
import { FabIcon } from "./components/FabIcon/FabIcon.js";
import { LegacyIconRenderer } from "../../helper/components/LegacyIconRenderer.js";
import { Backdrop } from "../backdrop/Backdrop.js";
import styles from "./Fab.module.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function Fab({
  children,
  onClick,
  icon,
  className,
  iconSize,
  showCloseIcon
}) {
  const [isOpen, setOpen] = useState(false);
  const hasItems = Children.count(children) > 0;
  const items = useMemo(() => children ? Children.map(children, child => {
    return /*#__PURE__*/cloneElement(child, {
      onClick: e => {
        if (child.props.onClick) {
          child.props.onClick(e);
        }
        setOpen(false);
      }
    });
  }) : [], [children]);
  const transitions = useTransition(isOpen ? items : [], {
    trail: 100,
    config: {
      tension: 180,
      friction: 16
    },
    from: {
      value: 0
    },
    enter: {
      value: 1
    },
    leave: {
      value: 0
    }
  });
  const handleOpen = useCallback(e => {
    if (onClick) {
      onClick(e);
    }
    if (hasItems) {
      setOpen(!isOpen);
    }
  }, [hasItems, isOpen, onClick]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: classnames(styles.fab, {
        [styles.open]: isOpen
      }, className),
      children: [transitions(({
        value
      }, item, _, index) => /*#__PURE__*/_jsx(animated.div, {
        className: styles.handler,
        style: {
          opacity: value,
          transform: value.to([0, 1], [0, (index + 1) * -60]).to(value => `translateY(${value}px)`)
        },
        children: item
      })), /*#__PURE__*/_jsx("button", {
        type: "button",
        className: classnames(styles.mainButton),
        onClick: handleOpen,
        children: icon ? isOpen || showCloseIcon ? /*#__PURE__*/_jsx(Close, {
          size: iconSize
        }) : /*#__PURE__*/_jsx(LegacyIconRenderer, {
          icon: icon,
          size: iconSize
        }) : /*#__PURE__*/_jsx(FabIcon, {
          open: isOpen
        })
      })]
    }), /*#__PURE__*/_jsx(Backdrop, {
      onClick: () => setOpen(false),
      open: isOpen
    })]
  });
}